module.exports = __webpack_public_path__ + "static/quiz_mhnn_manger_bw-915805f7c0f1c2c0aa187608609c20c3.png";